import { useState, useEffect, useContext } from 'react';
import { bbpsFetchBill, bbpsPayBill, bbpsValidateBill, getBbpsPlanDetails, getBbpsProvider, getBbpsProviderField } from '../../utils/api';
import { clickOutside, generateRandomString, getLocation, isEmpty, overLayers } from '../../utils/common';
import OfferBanner from '../OfferBanner';
import { AlertWrapper } from '../UI/styledConstants';
import { Wrapper } from '../Electricity/style';
import Loader from '../UI/Loader/Loader';
import BBPSReceipt from './BBPSReceipt';

import IconClose from '../../assets/images/IconClose';
import { GlobleContaxt } from '../../Context/GlobleContaxt';
import { useLocation } from 'react-router-dom';
import CustomDropdown from './CustomDropdown';
import Input from '../UIbox/Input';
import BillDetails from './BillDetails';
import Plan from './Plan';
import { useRef } from 'react';
import AmountSelector from './AmountSelector';

const initialControls = {
	account: '',
	billNumber: '',
	consumerMobileNumber: '',
	eroNumber: '',
	billerId: '',
	userId: '',
	amount: '',
	clientId: '',
	dateOfBirth: '',
	billPaymentRequest: '',
	emailId: '',
};

export default function BBPS({ className = '' }) {
	const [operatorList, setOperatorList] = useState([]);
	const [billDetails, setBillDetails] = useState({});
	const [planDetails, setPlanDetails] = useState([]);
	const [payDaital, setPayDaital] = useState({});
	const [controls, setControls] = useState({ ...initialControls });
	const [controlsErr, setControlsErr] = useState({ ...initialControls });
	const [message, setMessage] = useState({});
	const [loading, setLoading] = useState(false);
	const [dynamicField, setDynamicField] = useState([]);
	const [dynamicFieldValues, setDynamicFieldValues] = useState({});
	const [dynamicFieldValuesErr, setDynamicFieldValuesErr] = useState({});
	const [provider, setProvider] = useState('');
	const [activeMobilePop, setActiveMobilePop] = useState(false);
	const [validateBill_, setValidateBill] = useState('NOT_SUPPORTED');
	const [ip, setIp] = useState('');
	const [providerName, setProviderName] = useState('');
	const [require, setRequier] = useState({ validateBill: 'NOT_SUPPORTED', fetchRequirement: 'NOT_SUPPORTED', planMdmRequirement: 'NOT_SUPPORTED' });
	const [amount, setAmount] = useState(null);

	const [fetchRequirement, setFetchRequirement] = useState('NOT_SUPPORTED');
	const [planMdmRequirement, setPlanMdmRequirement] = useState('NOT_SUPPORTED');

	const numberReg = /^[0-9]+$/;
	const amountReg = /^[0-9.]+$/;

	const { setRefresh, refresh, geolocation, setGeolocation, setAlert } = useContext(GlobleContaxt);
	const popupRef = useRef(null);

	const onChangeHandler = async (e) => {
		if (isEmpty(geolocation?.latitude)) {
			if (isEmpty(sessionStorage.getItem('ID Token'))) {
				setAlert({ type: 'error', msg: 'Please login first to continue' });

				return;
			}
			setAlert({ type: 'warning', msg: 'Please allow access to your location', place: 'globle' });
			getLocation().then((position) => {
				setGeolocation(position);
			});

			return;
		}

		const { name, value } = e.target;
		if (name === 'consumerMobileNumber') {
			if (!numberReg.test(value) && value) {
				return false;
			}
		}
		if (name === 'amount') {
			if (!amountReg.test(value) && value) {
				return false;
			}
		}

		const _controls = {
			...controls,
			[name]: value,
		};

		setControls(_controls);
		setControlsErr({
			...controls,
			[name]: '',
		});
	};
	const { state } = useLocation();

	useEffect(() => {
		if (isEmpty(state)) return;
		setControls({
			...controls,
			providerType: state?.value,

		});
		fetch('https://api.ipify.org?format=json')
			.then((response) => response.json())
			.then((data) => setIp(data.ip))
			.catch((error) => console.error('Error fetching public IP:', error));
	}, [state]);

	const fetchUtilityBill = () => {
		const controlErr = {};
		if (controls.providerType === '') {
			controlErr.providerType = 'Please select provider type';
		} else if (controls.billerId === '') {
			controlErr.providerType = 'Please select operator';
		}
		const err = {};
		var returnValue = dynamicField.map((val) => {
			if (val.paramName === 'Amount') {
				setDynamicFieldValues({
					...dynamicFieldValues,
					[val.paramName]: 0,
				});
			} else {
				if (val.visibility === 'false') {
					return;
				}
				if (!dynamicFieldValues[val.paramName]) {
					err[val.paramName] = 'Please enter ' + val.paramName;
					return false;
				} else if (val?.regex !== '') {
					var regex = new RegExp(val?.regex);
					let text = dynamicFieldValues[val.paramName];
					if (!regex.test(text)) {
						err[val.paramName] = 'Please enter currect ' + val.paramName;
						setMessage({ type: 'error', msg: 'Please enter currect ' + val.paramName, place: 'form' });
						return false;
					}
				}
			}
		});

		if (!isEmpty(err) || !isEmpty(controlErr)) {
			setDynamicFieldValuesErr(err);
			setControlsErr(controlErr);
			return;
		}
		setLoading(true);
		const params = {
			billerId: controls.billerId,
			platform: 'WEB',
			request: dynamicFieldValues,
			deviceTags: [
				{
					name: 'INITIATING_CHANNEL',
					value: 'INT',
				},
				{
					name: 'IP',
					value: ip,
				},
				{
					name: 'MAC',
					value: 'DC-71-96-8A-D5-54',
				},
			],
		};

		bbpsFetchBill(params).then((response) => {
			setLoading(false);

			if (response?.success) {
				if (response?.data?.status?.toUpperCase() === 'SUCCESS') {
					setFetchRequirement('COMPLATE');
					setBillDetails({ ...response?.data?.response });
					setControls({ ...controls, amount: response?.data?.response?.billerResponse?.amount });
					setActiveMobilePop(true);
				} else {
					setAlert({ type: 'error', msg: response?.data?.response?.responseReason });
				}
			} else {
				if (response?.errorCodeList.length > 0 && !isEmpty(response?.errorCodeList[0])) {
					setAlert({ type: 'error', msg: response?.errorCodeList[0] });
				} else {
					setAlert({ type: 'error', msg: response?.msg });
				}
			}
		});
	};

	const payUtilityBill = (amount = '') => {
		const controlErr = {};
		if (controls?.providerType === '') {
			controlErr.providerType = 'Please select provider type';
		} else if (controls?.billerId === '') {
			controlErr.providerType = 'Please select operator';
		} else if (isEmpty(controls?.amount) && isEmpty(amount)) {
			controlErr.amount = 'Please enter amount';
		}
		const err = {};
		var returnValue = dynamicField.map((val) => {
			if (val.paramName === 'Amount') {
				setDynamicFieldValues({
					...dynamicFieldValues,
					[val.paramName]: 0,
				});
			} else {
				if (val.visibility === 'false') {
					return;
				}
				if (!dynamicFieldValues[val.paramName]) {
					err[val.paramName] = 'Please enter ' + val.paramName;
					return false;
				} else if (val?.regex !== '') {
					var regex = new RegExp(val?.regex);
					let text = dynamicFieldValues[val.paramName];
					if (!regex.test(text)) {
						err[val.paramName] = 'Please enter currect ' + val.paramName;
					}
				}
			}
		});

		if (!isEmpty(err) || !isEmpty(controlErr)) {
			setDynamicFieldValuesErr(err);
			setControlsErr(controlErr);
			return;
		}
		setLoading(true);
		let amt = controls?.amount;
		if (amount !== '') {
			amt = amount;
		}
		const accountNumber = dynamicField[0]?.paramName || '';

		const params = {
			amount: amt,
			refId: billDetails?.refId,
			clientRequestId: generateRandomString(13),
			request: dynamicFieldValues,
			billerId: controls?.billerId,
			billerName: providerName,
			platform: 'WEB',
			accountNumer: dynamicFieldValues?.[accountNumber],
			isFetchOrValidatedSupported: require?.validateBill === 'NOT_SUPPORTED' && require?.fetchRequirement === 'NOT_SUPPORTED' ? false : true,
			deviceTags: [
				{
					name: 'INITIATING_CHANNEL',
					value: 'INT',
				},
				{
					name: 'IP',
					value: ip,
				},
				{
					name: 'MAC',
					value: 'DC-71-96-8A-D5-54',
				},
			],
		};

		setAmount(amt);
		bbpsPayBill(params).then((resp) => {
			setLoading(false);
			setControls({
				...initialControls,
				providerType: controls?.providerType,
			});

			if (resp?.success) {
				if (resp?.data?.status?.toUpperCase() !== 'FAILURE') {
					setPayDaital(resp?.data);
					setRefresh(!refresh);
				} else {
					setPayDaital(resp?.data);
					let msg = '';
					if (!isEmpty(resp?.data?.response?.errorList)) {
						msg = resp?.data?.response?.errorList[0]?.errorDtl;
					} else {
						msg = resp?.data?.response?.responseReason;
					}
					setAlert({ type: 'error', msg: msg });
				}
			} else {
				closePop();
				if (resp?.errorCodeList.length > 0 && !isEmpty(resp?.errorCodeList[0])) {
					setAlert({ type: 'error', msg: resp?.errorCodeList[0] });
				} else {
					setAlert({ type: 'error', msg: resp?.msg });
				}
			}
		}).catch(() => {

		})
	};

	const validateBill = () => {
		const controlErr = {};
		if (controls.providerType === '') {
			controlErr.providerType = 'Please select provider type';
		} else if (controls.billerId === '') {
			controlErr.providerType = 'Please select operator';
		}
		const err = {};
		var returnValue = dynamicField.map((val) => {
			if (val.paramName === 'Amount') {
				setDynamicFieldValues({
					...dynamicFieldValues,
					[val.paramName]: 0,
				});
			} else {
				if (val.visibility === 'false') {
					return;
				}
				if (!dynamicFieldValues[val.paramName]) {
					err[val.paramName] = 'Please enter ' + val.paramName;
				} else if (val?.regex !== '') {
					var regex = new RegExp(val?.regex);
					let text = dynamicFieldValues[val.paramName];
					if (!regex.test(text)) {
						err[val.paramName] = 'Please enter currect ' + val.paramName;
					}
				}
			}
		});

		if (!isEmpty(err) || !isEmpty(controlErr)) {
			setDynamicFieldValuesErr(err);
			setControlsErr(controlErr);
			return;
		}
		setLoading(true);

		const params = {
			request: dynamicFieldValues,
			billerId: controls.billerId,
			platform: 'WEB',
		};

		bbpsValidateBill(params).then((resp) => {
			setLoading(false);

			if (resp?.success) {
				if (resp?.data?.status?.toUpperCase() !== 'FAILURE') {
					setAlert({ type: 'success', msg: 'Bill Validation Successful' });
					setValidateBill('COMPLETA');
				} else {
					let msg = '';
					if (!isEmpty(resp?.data?.response?.errorList)) {
						msg = resp?.data?.response?.errorList[0]?.errorDtl;
					} else {
						msg = resp?.data?.response?.complianceReason;
					}
					setAlert({ type: 'error', msg: msg });
				}
			} else {
				onCloseModal();
				if (resp?.errorCodeList.length > 0 && !isEmpty(resp?.errorCodeList[0])) {
					setAlert({ type: 'error', msg: resp?.errorCodeList[0] });
				} else {
					setAlert({ type: 'error', msg: resp?.msg });
				}
			}
		});
	};

	const onCloseModal = () => {
		setPayDaital({});
		setBillDetails({});
		setPlanDetails([]);
		setControls({ ...initialControls, providerType: state?.value });
		setDynamicField([]);
		setDynamicFieldValues({});
		setValidateBill('NOT_SUPPORTED');
		setFetchRequirement('NOT_SUPPORTED');
		setPlanMdmRequirement('NOT_SUPPORTED');
		setProvider('');
		setRequier({ validateBill: 'NOT_SUPPORTED', fetchRequirement: 'NOT_SUPPORTED', planMdmRequirement: 'NOT_SUPPORTED' });
	};

	const closePop = () => {
		onCloseModal();
		setAmount(null);
	};

	useEffect(() => {
		if (!isEmpty(message)) {
			setTimeout(() => {
				setMessage({});
			}, 5000);
		}
	}, [message]);

	const onChangeRequiredField = (e, val) => {
		const value = e.target.value;
		const name = e.target.name;
		if (val?.maxLength < val?.length) {
			return;
		}
		setDynamicFieldValues({
			...dynamicFieldValues,
			[name]: value,
		});
		setDynamicFieldValuesErr({
			...dynamicFieldValuesErr,
			[name]: '',
		});
	};

	useEffect(() => {
		getProviderList();

		setValidateBill('NOT_SUPPORTED');
		setFetchRequirement('NOT_SUPPORTED');
		setPlanMdmRequirement('NOT_SUPPORTED');
		setRequier({ validateBill: 'NOT_SUPPORTED', fetchRequirement: 'NOT_SUPPORTED', planMdmRequirement: 'NOT_SUPPORTED' });
	}, [controls.providerType, localStorage.getItem('ID Token')]);

	async function getProviderList() {
		if (isEmpty(localStorage.getItem('ID Token'))) {
			return;
		}
		if (!isEmpty(controls.providerType)) {
			setLoading(true);
			const response = await getBbpsProvider(controls.providerType);
			setLoading(false);
			if (response?.success) {
				setOperatorList(response?.data);
			}
		}
	}

	useEffect(() => {
		if (isEmpty(provider)) return;
		setLoading(true);
		getBbpsProviderField(provider).then((resp) => {
			setLoading(false);
			if (resp.success) {
				const _controls = {
					...controls,
					billerId: provider,
					amount: "",
				};
			
				setControls(_controls);
				setPayDaital({});
				setBillDetails({});
				setPlanDetails([]);
				setDynamicFieldValues({});
				const _dynamicField = (resp?.data?.customerParams || []).map((val) => {

					// if(val?.paramName === "Circle"){
					// 	return ({...val,inputType:"select",options:CircleList})
					// }

					if (!isEmpty(val.values)) {
						const options = val.values.split(",");
						return ({ ...val, inputType: "select", options })
					} else {
						return ({ ...val, inputType: "text" })
					}

				});

				setDynamicField([..._dynamicField]);
				setValidateBill(resp?.data?.supportBillValidation);
				setFetchRequirement(resp?.data?.fetchRequirement);
				setPlanMdmRequirement(resp?.data?.planMdmRequirement);
				setRequier({ validateBill: resp?.data?.supportBillValidation, fetchRequirement: resp?.data?.fetchRequirement, planMdmRequirement: provider?.planMdmRequirement });
			}
		});
	}, [provider]);

	const handleFormPlan = (data) => {
		setActiveMobilePop(false);
		setControls({ ...controls, amount: data });
	};

	const getPlan = () => {
		const controlErr = {};
		if (controls.providerType === '') {
			controlErr.providerType = 'Please select provider type';
		} else if (controls.billerId === '') {
			controlErr.providerType = 'Please select operator';
		}
		const err = {};
		var returnValue = dynamicField.map((val) => {
			if (val.paramName === 'Amount') {
				setDynamicFieldValues({
					...dynamicFieldValues,
					[val.paramName]: 0,
				});
			} else {
				if (val.visibility === 'false') {
					return;
				}
				if (!dynamicFieldValues[val.paramName]) {
					err[val.paramName] = 'Please enter ' + val.paramName;
					return false;
				} else if (val?.regex !== '') {
					var regex = new RegExp(val?.regex);
					let text = dynamicFieldValues[val.paramName];
					if (!regex.test(text)) {
						err[val.paramName] = 'Please enter currect ' + val.paramName;
						setMessage({ type: 'error', msg: 'Please enter currect ' + val.paramName, place: 'form' });
						return false;
					}
				}
			}
		});

		if (!isEmpty(err) || !isEmpty(controlErr)) {
			setDynamicFieldValuesErr(err);
			setControlsErr(controlErr);
			return;
		}
		setLoading(true);

		getBbpsPlanDetails(controls.billerId).then((response) => {
			setLoading(false);

			if (response?.success) {
				setPlanMdmRequirement('COMPLATE');
				if (response?.data) {
					setPlanDetails([...response?.data]);
					setActiveMobilePop(true);
				} else {
					setAlert({ type: 'error', msg: response?.data?.response?.responseReason });
				}
			} else {
				if (response?.errorCodeList.length > 0 && !isEmpty(response?.errorCodeList[0])) {
					setAlert({ type: 'error', msg: response?.errorCodeList[0] });
				} else {
					setAlert({ type: 'error', msg: response?.msg });
				}
			}
		});
	};

	const selectedPlanHandler = (plan) => {
		if (state?.label === 'Mobile Prepaid') {
			setControls({ ...controls, amount: plan?.amountInRupees });
			if (plan?.id) {
				setDynamicFieldValues({ ...dynamicFieldValues, Id: plan?.id });
			}
		}
	};




	useEffect(() => {
		overLayers(activeMobilePop, "sm")
		clickOutside(activeMobilePop, popupRef, () => { setActiveMobilePop(false) })
		return (() => {
			overLayers(false, "sm")
			clickOutside(false, popupRef, () => { setActiveMobilePop(false) })
		})
	}, [activeMobilePop])




	const isLic = () => ((provider.toUpperCase() === "LIFE00000NATL6") || (providerName.toUpperCase() === ("Life Insurance Corporation of India").toUpperCase()))
	return (
		<>
			{
				<Wrapper className={`tab-content-wrapper bbps`}>
					{!isEmpty(message) && message.place == 'globle' && (
						<AlertWrapper className={`${message.type} globle`}>
							<span className="close" onClick={() => setMessage({})}>
								×
							</span>
							{message.msg}
						</AlertWrapper>
					)}

					<div className="tab-content-left">
						<div className="flex justify-between headingText">
							<h2 className="">{state?.label}</h2>
							<img src={state?.img} alt="bbps logo" style={{ width: '30px' }} />
						</div>

						{
							<>
								<div className="form-field">
									<CustomDropdown
										list={operatorList}
										setProviderName={setProviderName}
										setProvider={setProvider}
										type="bill"
										setMessage={setMessage}
										error={''}
										provider={provider}
									/>
								</div>
								{dynamicField &&
									dynamicField.map((val, index) => {
									
										if (!(val.paramName === 'Amount')) {
											{
												if (val?.visibility === 'false') {
													return '';
												}

												return (
													<>
														<Input
															type={val?.inputType}
															label={val?.paramName}
															name={val?.paramName}
															onChange={(e) => onChangeRequiredField(e, val)}
															value={dynamicFieldValues[val?.paramName]}
															maxLength={val?.maxLength}
															minLength={val?.minLength}
															required={true}
															potions={val?.options}
															inputmode={val?.dataType?.toLowerCase()}
															error={dynamicFieldValuesErr?.[val?.paramName]}
														>
															{dynamicField[dynamicField.length - 1].visibility === 'true' && dynamicField.length - 1 === index && (
																<>
																	{fetchRequirement !== 'NOT_SUPPORTED' ? (
																		<button onClick={fetchUtilityBill} className="inputButton">
																			Fetch Bill
																		</button>
																	) : planMdmRequirement !== 'NOT_SUPPORTED' ? (
																		<button className="inputButton" onClick={() => getPlan()}>
																			Brows Plan
																		</button>
																	) : (
																		''
																	)}
																</>
															)}
															{dynamicField[dynamicField.length - 1].visibility !== 'true' && dynamicField.length - 2 === index && (
																<>
																	{fetchRequirement !== 'NOT_SUPPORTED' ? (
																		<button onClick={fetchUtilityBill} className="inputButton">
																			Fetch Bill
																		</button>
																	) : planMdmRequirement !== 'NOT_SUPPORTED' ? (
																		<button className="inputButton" onClick={() => getPlan()}>
																			Brows Plan
																		</button>
																	) : (
																		''
																	)}
																</>
															)}
														</Input>
													</>);
											}
										}
									})}

								{isEmpty(controls.billerId) ? (
									''
								) : (
									<Input
										label="Amount"
										name="amount"
										onChange={(e) => onChangeHandler(e)}
										value={controls?.amount}
										inputmode="numeric"
										error={controlsErr?.amount}
										disabled={!(fetchRequirement !== 'MANDATORY' && validateBill_ !== 'MANDATORY' && planMdmRequirement !== 'MANDATORY') || isEmpty(controls.billerId) || (billDetails?.additionalInfo)}
									>
										{validateBill_ !== 'NOT_SUPPORTED' ? (
											<button className="inputButton" onClick={() => validateBill()}>
												Validate Bill
											</button>
										) : (
											''
										)}
									</Input>
								)}

								{!isEmpty(message) && message.place == 'form' && (
									<AlertWrapper className={message.type}>
										<span className="close" onClick={() => setMessage({})}>
											×
										</span>
										{message.msg}
									</AlertWrapper>
								)}
								{

									!isEmpty(billDetails?.additionalInfo) && <AmountSelector options={billDetails?.additionalInfo} select={(amount) => setControls({ ...controls, amount: amount })} totalAmount={billDetails?.billerResponse?.amount} />

								}

								<button
									type="submit"
									className="button-outline"
									disabled={!(fetchRequirement !== 'MANDATORY' && validateBill_ !== 'MANDATORY' && planMdmRequirement !== 'MANDATORY') || isEmpty(controls.billerId)}
									onClick={() => payUtilityBill()}
								>
									Pay Now
								</button>

							</>
						}
					</div>

					<div ref={popupRef} className={`tab-content-right ${!activeMobilePop ? '' : 'active'}`}>
						<div
							className="d-m-block close-pop"
							onClick={() => {
								setActiveMobilePop(false);
							}}
						>
							<IconClose />
						</div>
						{!isEmpty(billDetails) && <BillDetails billDetails={billDetails} onClick={(amount) => payUtilityBill(amount)} />}
						{!isEmpty(planDetails) && <Plan planDetails={planDetails} serverType={state?.label} circle={dynamicFieldValues?.Circle} selectPlan={(plan) => selectedPlanHandler(plan)} />}
						{isEmpty(billDetails) && isEmpty(planDetails) && !loading && <OfferBanner />}
					</div>

					{!isEmpty(payDaital) && (
						<BBPSReceipt isLic={isLic()} payDaital={payDaital} onCloseModal={closePop} billDetails={billDetails} amount={amount} label={state?.label} dynamicFieldValues={dynamicFieldValues} />
					)}
					{loading && <Loader />}
				</Wrapper>
			}

		</>
	);
}
